export const searchActiveAction = (data) =>{
	return{
		type: "SEARCH_ACTIVE",
		payload: data
	}
}